import { KeyboardEvent, KeyboardEventHandler } from 'react';

interface Props {
  onKeyDownArrowUp?: (event: KeyboardEvent) => void;
  onKeyDownArrowDown?: (event: KeyboardEvent) => void;
  onKeyDownArrowLeft?: (event: KeyboardEvent) => void;
  onKeyDownArrowRight?: (event: KeyboardEvent) => void;
  onKeyDownEnter?: (event: KeyboardEvent) => void;
  onKeyDownSpace?: (event: KeyboardEvent) => void;
  onKeyDownBackspace?: (event: KeyboardEvent) => void;
  onKeyDownDelete?: (event: KeyboardEvent) => void;
}

export default function handleKeyDown<T extends Element>({
  onKeyDownArrowUp,
  onKeyDownArrowDown,
  onKeyDownArrowLeft,
  onKeyDownArrowRight,
  onKeyDownEnter,
  onKeyDownSpace,
  onKeyDownBackspace,
  onKeyDownDelete,
}: Props): KeyboardEventHandler<T> {
  return function onKeyDown(event: KeyboardEvent<T>) {
    switch (event.code || event.key) {
      case 'ArrowUp':
        onKeyDownArrowUp?.(event);
        break;
      case 'ArrowDown':
        onKeyDownArrowDown?.(event);
        break;
      case 'ArrowLeft':
        onKeyDownArrowLeft?.(event);
        break;
      case 'ArrowRight':
        onKeyDownArrowRight?.(event);
        break;
      case 'Enter':
        onKeyDownEnter?.(event);
        break;
      case 'Space':
      case ' ':
        onKeyDownSpace?.(event);
        break;
      case 'Backspace':
        onKeyDownBackspace?.(event);
        break;
      case 'Delete':
        onKeyDownDelete?.(event);
        break;
    }
  };
}
